import ass1 from './ass1.jpg'
import ass2 from './ass2.jpg'
import ass3 from './ass3.jpg'
import ass4 from './ass4.jpg'
import ass5 from './ass5.jpg'
import ass6 from './ass6.jpg'
import bag from './bag.jpg'
import computer from './computer.jpg'
import comput2 from './comp3.jpg'
import comput3 from './comp3.jpg'
import comput4 from './comp4.jpg'
import comput5 from './comp5.jpg'
import comput6 from './comp6special.jpg'
import comput7 from './comp7.jpg'
import comput8 from './desktop.jpg'
import comput9 from './leno.jpg'
import compput10 from './leno1.jpg'
import mic from './mic.jpg'
import server from './serv.jpg'
import printer from './printer.jpg'
import projector from './projector.jpg'
import mp3 from './mp3.jpg'
import remote from './remote.jpg'
import acer from './acer.jpg'

let all_product = [
    {
        id: 1,
        name: '8gig ram chip',
        category: 'accessory',
        image:ass1,
        price: 15000.00,
       
    },
    {
        id: 2,
        name: 'Wireless mouse',
        category: 'accessory',
        image:ass2,
        price: 10000,
        
    },
    {
        id: 3,
        name: 'Flash drive',
        category: 'accessory',
        image:ass3,
        price: 10000,
        
    },
    {
        id: 4,
        name: 'Mother board',
        category: 'accessory',
        image:ass4,
        price: 30000,
       
    },
    {
        id: 5,
        name: ' Multiport Usb connector',
        category: 'accessory',
        image:ass5,
        price: 30000,
        
    },
    {
        id: 6,
        name: 'Power adapter',
        category: 'accessory',
        image:ass6,
        price: 30000,
        
    },
    {
        id: 7,
        name: 'Lenovo Laptop',
        category: 'computer',
        image:computer,
        price: 300000,
        
    },
    {
        id: 8,
        name: 'Laptop bag',
        category: 'accessory',
        image:bag,
        price: 50000,
        
    },
    {
        id: 9,
        name: 'Acer Laptop',
        category: 'accessory',
        image:acer,
        price: 250000,
        
    },
    {
        id: 10,
        name: 'Hp Laptop',
        category: 'computer',
        image:comput2,
        price: 350000,
        
    },
    {
        id: 11,
        name: 'Memory module',
        category: 'accessory',
        image:comput3,
        price: 30000,
        
    },
    {
        id: 12,
        name: 'Laptop stand',
        category: 'accessory',
        image:comput4,
        price: 120000,
        
    },
    {
        id: 13,
        name: 'Split computer',
        category: 'computer',
        image:comput5,
        price: 450000,
       
    },
    {
        id: 14,
        name: 'Apple Laptop',
        category: 'computer',
        image:comput6,
        price: 1500000,
        
    },
    {
        id: 15,
        name: 'Lenovo Laptop',
        category: 'computer',
        image:comput7,
        price: 350000,
        
    },
    {
        id: 16,
        name: 'Desktop Computer',
        category: 'computer',
        image:comput8,
        price: 250000,
        
    },
    {
        id: 17,
        name: 'Lenovo Laptop',
        category: 'computer',
        image:comput9,
        price: 250000,
        
    },
    {
        id: 18,
        name: 'Lenovo Laptop',
        category: 'computer',
        image:compput10,
        price: 400000,
        
    },
    {
        id: 19,
        name: 'Microphone',
        category: 'accessory',
        image:mic,
        price: 30000,
       
    },
    {
        id: 20,
        name: 'Server',
        category: 'accessory',
        image:server,
        price: 800000,
        
    },
    {
        id: 21,
        name: 'Printer',
        category: 'printer',
        image:printer,
        price: 150000,
        
    },
    {
        id: 22,
        name: 'Projector',
        category: 'projector',
        image:projector,
        price: 150000,
        
    },
    {
        id: 23,
        name: 'Mp3 Player',
        category: 'accessory',
        image:mp3,
        price: 20000,
        
    },
    {
        id: 24,
        name: 'Remote controls',
        category: 'accessory',
        image:remote,
        price: 10000,
        
    },
];
export default all_product;
